import React, { useEffect, useState } from "react";
import "../dashboard/Profile/section/Privacy_policy.css";
import { toastMessage } from "../../utils/toastMessage";
import { fetchCmsDataApi } from "../../services/faqs";
import { fetchPublicCmsDataApi } from "../../services/common";


const Privacy = () => {
  const [privacyData, setPrivacyData] = useState("");

  const getAboutHandler = async () => {
    try {
      const { data } = await fetchPublicCmsDataApi({ type: "PRIVACY" });
      const { data: privacy, success, message } = data;
      if (success) {
        // toastMessage(message, "success", "privacy");
        setPrivacyData(privacy);
      }
    } catch (e) {
      console.log("Login:-", e.message);
    }
  };

//   console.log(privacyData, "privacyData");

  useEffect(() => {
    getAboutHandler();
  }, []);

  return (
    <>
      <div className="Privacy_policy">
        <div className="container_privacy_policy">
          <div className="privacy_policy_title">
            <h2>Privacy & Policy</h2>
          </div>
          {/* <div className="privacy_policy_heading">
            <h3>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.{" "}
            </h3>
  </div> */}
          <p
            dangerouslySetInnerHTML={{
              __html: privacyData?.description,
            }}
          ></p>
        </div>
      </div>
    </>
  );
};

export default Privacy;
